import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

function changeNativeLenguage() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { t, i18n } = useTranslation();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [language, setLenguage] = useState('en');

  const onChangeLanguaje = () => {
    i18n.changeLanguage(language);
    if (language === 'es') {
      setLenguage('en');
    } else {
      setLenguage('es');
    }
  };

  return (
    <React.Fragment>
        <i style={{cursor: 'pointer'}} onClick={onChangeLanguaje}>
          {t('navText')}
        </i>
    </React.Fragment>
  );
}

export default changeNativeLenguage;